import {
  OFFER_TELCEL_POSPAGO,
  OFFER_TELCEL_RECARGA,
  OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE,
  OFFER_TELCEL_PAQUETE_INTERNET_AMIGO,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO,
  OPEN_NEW_MICROAPP,
  REDIRECT,
  OFFER_TELCEL_AMIGO_PAGUITOS,
  OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN,
  OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO,
  BROWSE,
  NAVIGATE,
  IDS_AVAILABLE_TO_SERVICE_BALANCE_TELCEL,
  SERVICE_ID_TELCEL_PLANES,
  SERVICE_ID_TELCEL_POSPAGO,
  AMIGO_PAGUITOS,
  SERVICE_ID_TELCEL_RECARGA,
  ARCUS_BILLER_IDS_TELCEL_CONTENEDOR,
  ARCUS_BILLER_IDS,
} from "../../constants";
import { datadogRum } from "@datadog/browser-rum";
import { ClaroSDKService } from "../../services/sdk/ClaroSDKService";
import defaultMessagesMiniAppTelcel from "../../services/messaging/miTelcel.json";

export function validateUserAgent() {
  if (/Android/i.test(navigator.userAgent)) {
    return "android";
  }
}

export function getMessage(messages, code, flux) {
  const message = messages.find((message) => message.code === code);
  if (message) {
    return message;
  } else {
    if (flux && flux === "MiniAppTelcel") {
      return defaultMessagesMiniAppTelcel.find(
        (message) => message.code === code,
      );
    }
  }
}

export function getTypeOfferValue(typeOffer) {
  switch (typeOffer) {
    case "OFFER_TELCEL_POSPAGO":
      return OFFER_TELCEL_POSPAGO;
    case "OFFER_TELCEL_RECARGA":
      return OFFER_TELCEL_RECARGA;
    case "OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE":
      return OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE;
    case "OFFER_TELCEL_PAQUETE_INTERNET_AMIGO":
      return OFFER_TELCEL_PAQUETE_INTERNET_AMIGO;
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO;
    case "OFFER_TELCEL_AMIGO_PAGUITOS":
      return OFFER_TELCEL_AMIGO_PAGUITOS;
    case "OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL":
      return OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL;
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN;
    case "OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO":
      return OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO;
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO;
    default:
      break;
  }
}

export function getTypeEventValue(typeEvent) {
  switch (typeEvent) {
    case "OPEN_NEW_MICROAPP":
      return OPEN_NEW_MICROAPP;
    case "REDIRECT":
      return REDIRECT;
    case "BROWSE":
      return BROWSE;
    case "NAVIGATE":
      return NAVIGATE;
    default:
      break;
  }
}

export const datadogMonitor = (tagServiceId, sessionReplaySampleRate) => {
  datadogRum.init({
    applicationId: `${process.env.REACT_APP_DATADOG_APPLICATION_ID}`,
    clientToken: `${process.env.REACT_APP_DATADOG_CLIENT_TOKEN}`,
    site: `${process.env.REACT_APP_DATADOG_SITE}`,
    env: `${process.env.REACT_APP_DATADOG_ENV}`,
    service: `${tagServiceId}`,
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: parseInt(sessionReplaySampleRate),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });
};

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0;
};

export const setDomiciliationMsgInitialDate = (text, date) => {
  const setInitialDate = text.replaceAll("{fecha}", date);
  return setInitialDate.replaceAll("{periodicidad}", "mes");
};

export const formatEpochDate = (epochDate) => {
  const date = new Date(Number(epochDate));
  const yyyy = date.getFullYear();
  const numberString = String(date.getMonth() + 1);
  const mm = numberString.length ? "0" + numberString : numberString;
  const day = date.getDate();
  const dd = day < 10 ? "0" + day : day;
  return dd + "/" + mm + "/" + yyyy;
};

export const getSumDaysDate = (days) => {
  const today = new Date();
  const tzoffset = new Date().getTimezoneOffset() * 60000;
  return new Date(today.setDate(today.getDate() + days) - tzoffset)
    .toISOString()
    .split("T")[0];
};

export const getRequirementsAdvancementClaroPay = (
  user, 
  isContainerTelcel,
  serviceId,
  tagServiceId,
  prepago
) => {
  let isUserApprove = false;
  if(
    (
      serviceId == SERVICE_ID_TELCEL_PLANES || 
      serviceId == SERVICE_ID_TELCEL_RECARGA && tagServiceId != "serviciopagotelcelMenu"
    ) ||
    tagServiceId == "serviciopagotelcelMenu" && prepago
  ){
    if (user.advancePayment && !isContainerTelcel) {
      if (user.advancePayment.approved && Number(user.advancePayment.score) > 0) {
        isUserApprove = true;
      }
    }
  }
  return isUserApprove;
};

export const handleClickBannersTelcel = (
  onclick,
  isAnonimous,
  handleIpuntClick,
) => {
  const action = isAnonimous ? onclick.notLoggued : onclick.loggued;

  console.log(action);

  switch (action) {
    case "openLogin":
      ClaroSDKService.openLogin();
      handleIpuntClick();
      break;

    case "openOnboarding":
      ClaroSDKService.openOnBoarding(false);
      handleIpuntClick();
      break;

    case "setN2":
      const cardInfoItemClaroPay = {
        value: "claro-pay",
        mark: "999",
        type: 0,
        lastDigits: " ",
        update: false,
      };

      handleIpuntClick(null, "cardId", cardInfoItemClaroPay);
      break;

    default:
      break;
  }
};

export const existConfigFavorites = (dataConfigInputs, amount) => {
  const dataConf = dataConfigInputs.find((config) => config.id === "buttonBox");
  if (dataConf && dataConf.cp) {
    return dataConf.cp.find((input) => input.id === "favoritos") ? true : false;
  }
};

export const formatCurrency = new Intl.NumberFormat("en-Latn-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

export const formatRawCurrency = (value) => {
  return "$" + Math.floor(value).toString();
};

export const getUserApplyForAdvance = (user, amount) => {
  const { advancePayment } = user;
  if (advancePayment) {
    const { creditAmount, score, approved } = advancePayment;
    return (
      advancePayment && Number(score) > 0 && approved && creditAmount >= amount
    );
  }
};

export const getSelectedPlanByCost = (plans, cost) => {
  plans = plans.detail ? plans.detail : plans;
  return plans.find((plan) => plan.cost === cost);
};

export const getPlansForUpsell = (plans, cost) => {
  let plansForUpsell = plans.detail ? plans.detail : plans;
  plansForUpsell = plansForUpsell.filter((plan) => plan.cost >= cost);
  plansForUpsell.sort((a, b) => a.cost - b.cost);

  let seenMB = {};

  plansForUpsell = plansForUpsell.filter((plan) => {
    if (plan.mb && !seenMB[plan.mb]) {
      seenMB[plan.mb] = true;
      return true;
    }
    return false;
  });

  plansForUpsell = plansForUpsell.filter((plan) => plan.cost > cost);
  return plansForUpsell;
};

export const getNextPlanUpsell = (plansForUpsell, cost) => {
  const currentIndex = plansForUpsell.findIndex((plan) => plan.cost === cost);
  return plansForUpsell[currentIndex + 1];
};

export function getDomiciliationExpirationDate(expirationDate) {
  const dateFromForm = new Date(expirationDate);

  const monthFromForm = dateFromForm.getMonth(); //(January gives 0)

  const dayFromform = dateFromForm.getDate();

  const yearFromForm = dateFromForm.getFullYear();

  const currentDate = new Date();

  const currentday = currentDate.getDate();

  const currentMoth = currentDate.getMonth();

  if (monthFromForm === 11) {
    const nextMonthOfYearTotalDays = new Date(yearFromForm + 1, 1, 0).getDate();

    const nextMonthTotalDays = new Date(
      yearFromForm,
      monthFromForm + 2,
      0,
    ).getDate();

    if (dayFromform <= currentday) {
      if (dayFromform <= nextMonthOfYearTotalDays) {
        return `${yearFromForm + 1}/01/${dayFromform}`;
      }
      if (dayFromform > nextMonthTotalDays) {
        return `${yearFromForm + 1}/01/${nextMonthTotalDays}`;
      }
    }
    return expirationDate;
  } else {
    const nextMonthTotalDays = new Date(
      yearFromForm,
      monthFromForm + 2,
      0,
    ).getDate();

    if (monthFromForm < currentMoth) {
      console.log(monthFromForm, "mes seleccionado es menor a mes actual");
      if (dayFromform <= nextMonthTotalDays) {
        return `${yearFromForm}/${monthFromForm + 2}/${dayFromform}`;
      }
      if (dayFromform > nextMonthTotalDays) {
        return `${yearFromForm}/${monthFromForm + 2}/${nextMonthTotalDays}`;
      }
      return expirationDate;
    } else if (monthFromForm === currentMoth) {
      if (dayFromform <= currentday && dayFromform <= nextMonthTotalDays) {
        return `${yearFromForm}/${monthFromForm + 2}/${dayFromform}`;
      }
      if (dayFromform <= currentday && dayFromform > nextMonthTotalDays) {
        return `${yearFromForm}/${monthFromForm + 2}/${nextMonthTotalDays}`;
      }
      return expirationDate;
    } else {
      return expirationDate;
    }
  }
}

export function buttonDomiciliationConfigExist(dataConfigElements) {
  const buttonBoxElements = dataConfigElements.find(
    (elem) => elem.id == "buttonBox",
  );
  if (buttonBoxElements) {
    const result = buttonBoxElements.cp.find(
      (button) => button.id == "domiciliar",
    );
    return result ? true : false;
  } else {
    return false;
  }
}

export function buttonMorePackagesConfigExist(dataConfigElements) {
  const buttonBoxElements = dataConfigElements.find(
    (elem) => elem.id == "buttonBox",
  );
  if (buttonBoxElements) {
    const result = buttonBoxElements.cp.find(
      (button) => button.id == "mas_paquetes_pospago",
    );
    return result ? true : false;
  } else {
    return false;
  }
}

export function getPaymentFlowForTaggeo(isAnonimous, msisdn, paymentMethods) {
  if (isAnonimous && msisdn) {
    return "Solo MSISDN";
  }

  if (!isAnonimous) {
    if (
      !paymentMethods ||
      (!paymentMethods.hasN2 && paymentMethods.cardList.length === 0)
    ) {
      return "Usuario sin método";
    }
    if (
      paymentMethods &&
      (paymentMethods.hasN2 || paymentMethods.cardList.length > 0)
    ) {
      return "Usuario con método";
    }
  }
}

export const getUrlBalances = (isContainer, serviceId, needsDelay) => {
  const {
    REACT_APP_BALANCE_CP_TELCEL,
    REACT_APP_BALANCE_CP_TELCEL_APIKEY,
    REACT_APP_BALANCE_CP_SERVICIOS,
    REACT_APP_BALANCE_CP_SERVICIOS_APIKEY,
  } = process.env;
  const isBalanceTelcel =
    IDS_AVAILABLE_TO_SERVICE_BALANCE_TELCEL.includes(serviceId);
  if (isContainer) {
    if (isBalanceTelcel) {
      return {
        url: REACT_APP_BALANCE_CP_TELCEL,
        apiKey: REACT_APP_BALANCE_CP_TELCEL_APIKEY,
        needsDelay: needsDelay,
      };
    } else {
      return {
        url: REACT_APP_BALANCE_CP_SERVICIOS,
        apiKey: REACT_APP_BALANCE_CP_SERVICIOS_APIKEY,
        needsDelay: false,
      };
    }
  } else {
    if (isBalanceTelcel) {
      return {
        url: REACT_APP_BALANCE_CP_TELCEL,
        apiKey: REACT_APP_BALANCE_CP_TELCEL_APIKEY,
        needsDelay: needsDelay,
      };
    } else {
      return {
        url: REACT_APP_BALANCE_CP_SERVICIOS,
        apiKey: REACT_APP_BALANCE_CP_SERVICIOS_APIKEY,
        needsDelay: false,
      };
    }
  }
};

export const getDomiciliationWindowId = (requestCodeKey = "") => {
  return `${requestCodeKey}_pago_servicios_${sessionStorage.getItem("domiciliationWindowId")}`;
};

export const assignTagServiceTelcel = (serviceId, tagServiceId) => {
  let newTagServiceId;

  switch (true) {
    case serviceId === SERVICE_ID_TELCEL_PLANES:
      newTagServiceId = "telcelAmigoSinLimitePs";
      break;
    case serviceId === SERVICE_ID_TELCEL_POSPAGO:
      newTagServiceId = "TelcelPospagoPS";
      break;
    case serviceId === AMIGO_PAGUITOS:
      newTagServiceId = "amigopaguitos";
      break;
    case serviceId === SERVICE_ID_TELCEL_RECARGA:
      newTagServiceId = "serviciopagotelcel";
      break;
    default:
      newTagServiceId = tagServiceId;
  }

  return newTagServiceId;
};

export const getServicesTelcel = (serviceId) => {
  switch (Number(serviceId)) {
    case 146:
      return "servicios telcel";
    case 113:
      return "servicios telcel";
    case 143:
      return "servicios telcel";
    case 247:
      return "servicios telcel";
    case 254:
      return "servicios telcel";
    case 285:
      return "servicios telcel";
    default:
      return "terceros";
  }
};

export const idIsvalidCheckBalanceArcus = (isContainerTelcel, serviceId) => {
  if (isContainerTelcel) {
    return ARCUS_BILLER_IDS_TELCEL_CONTENEDOR.includes(serviceId);
  } else {
    return ARCUS_BILLER_IDS.includes(serviceId);
  }
};

export const taggeoCleanString = (texto) => {
  if (texto) {
    return (
      texto
        // 1. Normaliza para separar acentos
        .normalize("NFD")
        // 2. Elimina los caracteres diacríticos (acentos)
        .replace(/[\u0300-\u036f]/g, "")
        // 3. Convierte a minúsculas
        .toLowerCase()
        // 4. Elimina comas, puntos, signos de exclamación/interrogación y comillas
        .replace(/[.,!?¿¡"']/g, "")
        // 5. Elimina espacios extra al inicio y final
        .trim()
    );
  } else {
    return "";
  }
};
/**
 * Get user navigator by navigator object interface
 * @return {null|Array} Array if navigator match, otherwise returns false
 ***/
export const getNavigator = {
  isIOS: () => {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i) || false;
  },
  isAndroid: () => {
    return navigator.userAgent.match(/Android/i) || false;
  },
};
